import { camelCase } from 'lodash-es';
import { useTranslation } from 'next-i18next/pages';
import React from 'react';

import { TypeOfWork } from '@pflegia/types/api/candidate/type-of-work';
import { FunnelQuestion, FunnelQuestionCategory } from '@pflegia/types/api/funnel/questions';
import { transformedEventProperties } from '@pflegia/ui/application/marketing/tracking/utils/transformed-event-properties';
import HeroButton from '@pflegia/ui/shared/hero-button/HeroButton';

import { useFunnelState } from '@funnel/hooks/use-funnel-state';

import { FUNNEL } from '@shared/application/constants';
import { getEventProperty } from '@shared/application/marketing/funnel-event-marketing-to-event-property';
import { funnelQuestionToFunnelEventMarketing } from '@shared/application/marketing/funnel-question-to-funnel-event-marketing';
import { useTracking } from '@shared/application/tracking.service';

export interface TypeOfWorkButtonsProps {
  typesOfWork: TypeOfWork[];
}

const TypeOfWorkButtons: React.FC<TypeOfWorkButtonsProps> = ({ typesOfWork }) => {
  const { t } = useTranslation('candidateFields', { keyPrefix: 'typeOfEmployer' });
  const { trackEventRegistration } = useTracking();

  const setAnswers = useFunnelState(state => state.setAnswers);

  const handleTypeOfWorkClick = (typeOfWork: TypeOfWork) => {
    const questionId = FunnelQuestion.EmployeeType;
    const eventName = funnelQuestionToFunnelEventMarketing[questionId];
    trackEventRegistration(
      eventName,
      transformedEventProperties({ [getEventProperty(eventName)]: typeOfWork }),
      questionId,
      FunnelQuestionCategory.Field,
    );
    // Setting by default the nursing area to MedicalStaff and the selected type of work.
    setAnswers({ [FunnelQuestion.EmployeeType]: [typeOfWork] });
  };

  return (
    <div className='xs:gap-2 xs:space-y-0 grid grid-cols-1 justify-center space-y-2 md:grid-cols-1 lg:grid-cols-2'>
      {typesOfWork.map(typeOfWork => (
        <HeroButton
          dataTestId={`type-of-work-button-${typeOfWork}`}
          href={{ pathname: FUNNEL, query: { id: FunnelQuestion.HighlightJobTitle } }}
          key={typeOfWork}
          onClick={() => handleTypeOfWorkClick(typeOfWork)}>
          {t(camelCase(typeOfWork))}
        </HeroButton>
      ))}
    </div>
  );
};

export default TypeOfWorkButtons;
